const Resources = {

    table_headers: [
        { 
            text:     'Code',
            align:    'start',
            value:    'code',
        },
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Options',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Bed Codes',
            href:   '/options-bed-codes',
            arrow:  "",
        },
    ],

}

export default Resources;